import { Graphics } from "pixi.js";
import type { ShipSnapshot } from "@frontier/protocol/contracts";

const ARC_LENGTH = (Math.PI * 100) / 180;
const SCREEN_GAP = 7;
const STROKE_WIDTH = 2.5;

function fraction(value: number, maximum: number): number {
  return maximum > 0 ? Math.min(1, Math.max(0, value / maximum)) : 0;
}

/** Screen-thickness meters live beside the heading, so turning never rotates status. */
export class LocalShipVitals {
  readonly graphics = new Graphics({ label: "local-vitals" });
  private radius = -1;
  private hull = -1;
  private shield = -1;
  private energy = -1;

  render(
    state: ShipSnapshot,
    local: boolean,
    hullRadius: number,
    zoom: number,
  ): void {
    this.graphics.visible = local && !state.dead && !state.docked;
    if (!this.graphics.visible) return;
    const scale = zoom > 0 ? zoom : 1;
    const radius = hullRadius * scale + SCREEN_GAP;
    const hull = fraction(state.hp, state.maxHp);
    const shield = fraction(state.shield, state.maxShield);
    const energy = fraction(state.energy, state.maxEnergy);
    this.graphics.scale.set(1 / scale);
    if (
      radius === this.radius &&
      hull === this.hull &&
      shield === this.shield &&
      energy === this.energy
    )
      return;
    this.radius = radius;
    this.hull = hull;
    this.shield = shield;
    this.energy = energy;
    this.graphics.clear();
    const meters = [
      {
        start: (Math.PI * 130) / 180,
        value: hull,
        color: hull < 0.3 ? 0xff7469 : 0x9bd6b0,
      },
      { start: (Math.PI * 250) / 180, value: shield, color: 0x75caff },
      { start: (Math.PI * 10) / 180, value: energy, color: 0xe9c17a },
    ];
    for (const meter of meters) {
      this.graphics
        .beginPath()
        .arc(0, 0, radius, meter.start, meter.start + ARC_LENGTH)
        .stroke({
          color: 0x29414f,
          width: STROKE_WIDTH + 1,
          alpha: 0.8,
          cap: "round",
        });
      if (meter.value > 0)
        this.graphics
          .beginPath()
          .arc(
            0,
            0,
            radius,
            meter.start,
            meter.start + ARC_LENGTH * meter.value,
          )
          .stroke({
            color: meter.color,
            width: STROKE_WIDTH,
            alpha: 0.95,
            cap: "round",
          });
    }
  }
}
